import { FC } from 'react';
import { IconType } from './icon-types';

interface OperatingSystemLogoDto {
  operatingSystems: string[];
  path: string;
  iconType: IconType;
}

const operatingSystemLogos: OperatingSystemLogoDto[] = [
  {
    operatingSystems: ['ANDROID'],
    iconType: IconType.IMAGE,
    path: '/media/logos/android-logo.png'
  },
  {
    operatingSystems: ['APPLE', 'IOS'],
    iconType: IconType.IMAGE,
    path: '/media/logos/apple-logo.png'
  },
  {
    operatingSystems: ['CHROME'],
    iconType: IconType.IMAGE,
    path: '/media/logos/chrome-logo.png'
  },
  {
    operatingSystems: ['LINUX'],
    iconType: IconType.IMAGE,
    path: '/media/logos/linux-logo.png'
  },
  {
    operatingSystems: ['WINDOWS'],
    iconType: IconType.IMAGE,
    path: '/media/logos/microsoft-logo.png'
  }
];

const OperatingSystemLogo: FC<{
  operatingSystem: string;
  imageClasses?: string;
  iconClasses?: string;
}> = ({
  operatingSystem,
  imageClasses,
  iconClasses
}: {
  operatingSystem: string;
  imageClasses?: string;
  iconClasses?: string;
}) => {
  const operatingSystemUpper = operatingSystem.toUpperCase();

  const logoToUse = operatingSystemLogos.find((logo) =>
    logo.operatingSystems.some((os) => operatingSystemUpper.includes(os))
  );

  return logoToUse ? (
    <>
      {logoToUse.iconType === IconType.FLATICON ? (
        <i className={`${logoToUse.path} ${iconClasses}`}></i>
      ) : (
        <img
          src={logoToUse.path}
          className={imageClasses}
          alt={operatingSystem}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default OperatingSystemLogo;
